<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 48 48"
>
  <rect x="10" y="7" width="10" height="34" fill="#e21b1b" />
  <rect x="29" y="7" width="10" height="34" fill="#e21b1b" />
</svg>
